import { SVGProps } from 'react';

export const FilterIcon = (props?: SVGProps<SVGSVGElement>) => {
  return (
    <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M0.5 1.5C0.5 1.22386 0.723858 1 1 1H9C9.27614 1 9.5 1.22386 9.5 1.5C9.5 1.63261 9.44732 1.75979 9.35355 1.85355L6 5.20711V8.5C6 8.67688 5.90054 8.84046 5.74186 8.9239L4.74186 9.4239C4.58957 9.50367 4.40745 9.50519 4.25382 9.42761C4.10019 9.35002 4 9.1851 4 9V5.20711L0.646447 1.85355C0.552678 1.75979 0.5 1.63261 0.5 1.5Z"
        fill="currentColor"
      />
    </svg>
  );
};
